import { Connector } from 'models/Connector';

/** Message shown in status tooltips (API may use snake_case or camelCase). */
export function getConnectorStatusMessage(connector: Connector): string {
  const r = connector as Record<string, unknown>;
  const raw =
    connector.status_message ??
    connector.statusMessage ??
    r.status_message ??
    r.statusMessage;
  if (raw === null || raw === undefined) {
    return '';
  }
  if (typeof raw === 'object') {
    return '';
  }
  const s = String(raw).trim();
  return s;
}

/** HTTP-style buckets for connector sync state (from API `status_code`). */
export type ConnectorSyncStatusKey = '2xx' | '4xx' | '5xx' | 'pending' | 'other';

export const CONNECTOR_SYNC_STATUS_FILTER_KEYS: ConnectorSyncStatusKey[] = [
  '2xx',
  '4xx',
  '5xx',
  'pending',
  'other'
];

export function parseConnectorStatusCode(raw: unknown): number | null {
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  const n = typeof raw === 'number' ? raw : Number(raw);
  if (!Number.isFinite(n)) {
    return null;
  }
  return n;
}

export function getConnectorSyncStatusKey(
  connector: Connector
): ConnectorSyncStatusKey {
  const code = parseConnectorStatusCode(connector.status_code);
  if (code === null) {
    return 'pending';
  }
  if (code >= 200 && code < 300) {
    return '2xx';
  }
  if (code >= 400 && code < 500) {
    return '4xx';
  }
  if (code >= 500 && code < 600) {
    return '5xx';
  }
  return 'other';
}

export function getConnectorSyncStatusLabel(
  key: ConnectorSyncStatusKey
): string {
  switch (key) {
    case '2xx':
      return 'Ok';
    case '4xx':
      return 'Action Required';
    case '5xx':
      return 'Retrying';
    case 'pending':
      return 'Pending';
    default:
      return 'Unknown';
  }
}

/** Solid dot color classes (match Enabled column style). */
export function getConnectorSyncStatusDotClass(key: ConnectorSyncStatusKey): string {
  switch (key) {
    case '2xx':
      return 'bg-success';
    case '4xx':
      return 'bg-danger';
    case '5xx':
    case 'pending':
      return 'bg-warning';
    default:
      return 'bg-secondary';
  }
}
